<template>
  <div class="login-container" :style="note">
    <el-row v-show="this.$util.defLanguage=='zh'">
    <span style="margin-top:10px;margin-right:10px;float:right;width:100px;">
      <el-image
        :src="require('@/assets/appTwoCode.png')"
        z-index:9999
        lazy:true
        fit:cover
        style="width:100px;height:100px;cursor:pointer">
      </el-image>
      <span style="width:100px;color:white;display:flex;justify-content:center;">{{$t('login.app-txt')}}</span>
    </span>  
    </el-row>
    <el-row v-show="this.$util.defLanguage=='en'">
    <span style="margin-top:10px;margin-right:10px;float:right;width:100px;">
      <el-image
        :src="require('@/assets/hwAndroid.png')"
        z-index:9999
        lazy:true
        fit:cover
        style="width:100px;height:100px;cursor:pointer">
      </el-image>
      <span style="width:100px;color:white;display:flex;justify-content:center;">{{$t('login.hw-app-txt')}}</span>
    </span>
    </el-row> 
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      status-icon
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
    <el-dialog
      :title="$t('register.imageCode-msg-input')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="imageCodeVisible"
      width="400px"
    >
      <el-form-item>
       <el-col :span="12">
          <el-input type="text" v-model="inputImageCode" :placeholder="$t('register.imageCode')"></el-input>
       </el-col>
       <el-col :span="12">
        <el-image
          style="width:150px;margin-left:5px"
          :src="imageSrc"
          fit="fill"
          @click="changeCode"
        ></el-image>
       </el-col>
    </el-form-item>
     <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="confirmImageCode">{{$t("register.confirm")}}</el-button>
          <el-button type="primary" @click="imageCodeVisible=false">{{$t("register.cancel")}}</el-button>
     </el-form-item>
    </el-dialog>

     <el-row>
      <el-col :span="16">
       <h2 class="title" style="color:white">{{$t("register.logo")}}</h2>
      </el-col>
      <el-col :span="8" align="end">
        <el-link @click="back" type="warning">{{$t('passwordForget.breakHome')}}</el-link>
      </el-col> 
     </el-row>
      <el-row>
        <el-row>
          <el-col :span="10">
             <country @showCountry="updateCountry" :sendData="toCountry"></country>
          </el-col>  
          <el-col :span="14" align="end">
            <el-radio-group v-model="loginType">
              <!-- <el-radio-button :label="1" value="1">{{
                $t("register.mobile")
              }}</el-radio-button> -->
              <el-radio-button :label="0" value="0">{{
                $t("register.mailbox")
              }}</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-form-item
          :label="$t('register.username')"
          label-width="150px"
          prop="username"
          style="margin-top:15px;"
          class="item"
        >
          <el-input
            type="phone"
            v-model="ruleForm2.username"
            :placeholder="$t('register.username')"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-form-item :label="$t('register.password')" label-width="150px" prop="password" class="item">
        <el-input
          type="password"
          v-model="ruleForm2.password"
          maxlength="18" 
          :placeholder="$t('register.password')"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('register.confirmPassword')" label-width="150px" prop="password1" class="item">
        <el-input
          type="password"
          v-model="ruleForm2.password1"
          maxlength="18" 
          :placeholder="$t('register.confirmPassword')"
          auto-complete="off"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('register.validCode')" label-width="150px" prop="validCode" class="item">
        <el-input
          type="text"
          maxlength="6"
          v-model="ruleForm2.validCode"
          :placeholder="$t('register.validCode')"
          auto-complete="off"
          style="width:110px"
        ></el-input>
        <el-button type="success" @click="openImageDialog"
          >{{$t('register.getValidCode')}}</el-button
        >
      </el-form-item>

      <!-- <el-form-item style="width:100%;color:white">
        <el-col :span="16">
          <country @showCountry="updateCountry" :sendData="toCountry"></country>
        </el-col>
        <el-col :span="8">
          <el-select v-model="languageType" @change="languagesChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-form-item> -->

      <el-form-item style="width:100%;">
        <el-button
          type="success"
          style="width:100%;"
          @click="registerSubmit"
          :loading="logining"
          >{{$t('register.register')}}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import country from "./country.vue";
export default {
  //官方推荐select国际化加载数据须在computed
  computed: {
    // options() {
    //   return [
    //     { value: "0", label: this.$t("login.zh") },
    //     { value: "1", label: this.$t("login.en") }
    //   ];
    // }
  },
  data() {
    var validateUserName = (rule, value, callback) => {
      if (this.loginType == 1) {
        var boolean = new RegExp("^[1-9][0-9]*$").test(value);
        if (!boolean) {
          callback(new Error(this.$t("register.mobile-msg-error")));
        } else {
          callback();
        }
      } else {
        // var mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        // if (!mailReg.test(value)) {
        //   callback(new Error(this.$t("register.email-msg-error")));
        // } else {
        //   callback();
        // }
        if(value.indexOf("@")!=-1){
          callback();
        }else{
           callback(new Error(this.$t("register.email-msg-error")));
        }
        
      }
    };
    var validatePassword1= (rule, value, callback) => {
      if(value!=this.ruleForm2.password){
        callback(new Error(this.$t("register.confirmPassword-error")));
      }else{
        callback();
      }
    };
    return {
      imageCodeVisible: false,
      imageSrc:null,
      imageCodeId:"",
      inputImageCode:"",
      loginType: "0",
      logining: false,
      toCountry: "86",
      languageType: "0",
      ruleForm2: {
        username: "",
        password: "",
        password1: "",
        validCode: "",
      },
      rules2: {
        username: [
          {
            required: true,
            message: this.$t("register.accout-null"),
            trigger: "blur"
          },
          // { min: 4, max: 18, message: this.$t("register.account-msg"), trigger: "blur" },
          { validator: validateUserName, trigger: "blur" }
        ],
        password: [
          { required: true, message: this.$t("register.password-null"), trigger: "blur" }
        ],
        password1: [
          {
            required: true,
            message: this.$t("register.confirmPassword-null"),
            trigger: "blur"
          },
          { validator: validatePassword1, trigger: "blur" }
        ],
        validCode: [
          { required: true, message: this.$t("register.validCode-msg-input"), trigger: "blur" }
        ]
      },
      checked: false,
      note: {
        backgroundImage: "url(" + require("../assets/login.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }
    };
  },
  components: {
    country
  },
  created() {
  },  
  methods: {
     //切换验证码图片
    changeCode(){
         this.getValidCode();//获取图片验证码
    },
    //打开获取图形码
    openImageDialog(){
      if(this.ruleForm2.username==""||this.ruleForm2.username==null){
          this.$message({
            message:this.$t("register.accout-null"),
            type: "warning"
        });
         return false;
      }
      this.getValidCode();
      this.imageCodeVisible=true;
    },
    //获取验证码
    confirmImageCode(){
      if(this.inputImageCode==""||this.inputImageCode==null){
         this.$message({
            message: this.$t("register.imageCode-msg-input"),
            type: "warning"
        });
        return false;
      }
      var loginType = this.loginType;
          var username = this.ruleForm2.username;
          var password = this.ruleForm2.password;
          var toCountry = this.toCountry;
          var inputImageCode =this.inputImageCode
          var imageCodeId=this.imageCodeId;
          var formData = new FormData();
          formData.append("account", username);
          formData.append("accountType", loginType);
          formData.append("countryId", toCountry);
          formData.append("picValidCode", inputImageCode);
          formData.append("picValidCodeId", imageCodeId);
          formData.append("validCodeType", 0);
      this.$server.exam("/customer/security/getAccountValidCode", formData).then(data => {
        if (data.code == 200) {
          this.imageCodeVisible=false;
          if (data["code"] == 200) {
            this.$message({
             message: data.message,
             type: "success"
            });
          } else {
            this.$message({
             message: data.message,
             type: "warning"
            });
          }
        } else {
          this.logining = false;
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    getValidCode() {
      var formData = new FormData();
      this.$server.exam("/customer/security/getPicValidCode", formData).then(data => {
        if (data.code == 200) {
          if (data["code"] == 200) {
            var res = data.data;
            // alert(window.JSON.stringify(res));
            var imageBase64 = res.imageBase64;
            this.imageCodeId = res.codeId;
            this.imageSrc=imageBase64;
          } else {
            this.$message({
             message: data.message,
             type: "warning"
            });
          }
        } else {
          this.logining = false;
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    back() {
      this.$router.push({ path: "/" });
    },
    registerSubmit(event) {
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          this.logining = true;
          var loginType = this.loginType;
          var username = this.ruleForm2.username;
          var password = this.ruleForm2.password;
          var toCountry = this.toCountry;
          var validCode =this.ruleForm2.validCode
          var formData = new FormData();
          formData.append("account", username);
          formData.append("userName", username);
          formData.append("accountType", loginType);
          formData.append("password",this.$md5(password+"2FB9680E").toLowerCase());
          formData.append("countryId", toCountry);
          formData.append("validCode", validCode);
          
          this.$server.exam("/customer/security/registerPersonal", formData).then(data => {
            if (data.code == 200) {
              this.logining = false;
              this.$message({
                message: data.message,
                type: "success"
              });
              // sessionStorage.setItem("user", this.ruleForm2.username);
              // this.$router.push({ path: "container" });
            } else {
              this.logining = false;
              this.$message({
                message: data.message,
                type: "warning"
              });
            }
          });
          // if (username === "admin" &&password === "123456") {
          //   this.logining = false;
          //   // sessionStorage.setItem("user", this.ruleForm2.username);
          //   this.$router.push({ path: "container" });
          // } else {
          //   this.logining = false;
          //   this.$alert("username or password wrong!", "info", {
          //     confirmButtonText: "ok"
          //   });
          // }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
    languagesChange(event) {
      switch (this.languageType) {
        case "0":
          this.$i18n.locale = "zh";
          this.languageType = "0";
          break;
        case "1":
          this.$i18n.locale = "en";
          this.languageType = "1";
          break;
      }
    },
    updateCountry(data) {
      //触发子组件城市选择-选择城市的事件
      this.toCountry = data; //改变了父组件的值
      // alert('toCountry:'+this.toCountry)
    },
  }
};
</script>

<style scoped>
.whiteItem{
  color: white;
}
.login-container {
  width: 100%;
  height: 100%;
}
.login-page {
  position: absolute;
  left: 50%;
  top: 13%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  -webkit-border-radius: 5px;
  border-radius: 5px;
  /*margin: 0 auto;*/
  width: 380px;
  padding: 15px 35px 15px;
  background: rgba(0, 0, 0, 0.6) none repeat scroll !important; /* rgba(0, 0, 0, 0.2) 前三个确定颜色，最后0.2确定透明度 */
  /*实现FireFox背景透明，文字不透明*/
  filter: Alpha(opacity=10);
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 25px #cac6c6;
}
/* label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
  color: white;
} */
</style>



// WEBPACK FOOTER //
// src/components/register.vue